export const VALIDATION={
minDescriptionWords:10,
maxDescriptionWords:100,
minPrice:1,
maxPhoneDigits:10,
minPasswordLength:6,

}